<template>

  <month-base-bar>
    {{ item.opened + item.completed }} – PARCS
  </month-base-bar>

</template>

<script setup lang="ts">

import MonthBaseBar from './MonthBaseBar.vue'
import type { MonthParcsInventoryCalendarItem } from '../../calendarItemTypes'

/**
 * Props
 */

interface Props {
  item: MonthParcsInventoryCalendarItem
}

defineProps<Props>()

</script>
